import React, { useState } from "react";
import { Button, Modal, ModalBody, ModalHeader } from "reactstrap";
import { DetailedErrorAlert } from "../../../components/DetailedErrorAlert";
import { adminApi as api, extractErrorMessage } from "../../../util/api";
import { snakifyKeys } from "../../../util/helpers";
import { S3DirectoryForm } from "./S3DirectoryForm";

export const AddS3DirectoryModal = ({ resourcePath, s3Directory, onAdd }) => {
  const [open, setOpen] = useState(false);
  const [error, setError] = useState(null);
  const toggleModal = () => setOpen(!open);
  const title = "Add S3 Directory";

  const handleCreate = async (values) => {
    setError(null);
    try {
      const { data } = await api.post(`${resourcePath}/s3_directories`, snakifyKeys({ s3Directory: values }));

      if (data) {
        onAdd(data);
      }

      setOpen(false);
    } catch (err) {
      setError(extractErrorMessage(err));
    }
  };

  return (
    <>
      <Button onClick={toggleModal}>{title}</Button>

      <Modal isOpen={open} toggle={toggleModal} size="lg">
        <ModalHeader toggle={toggleModal}>{title}</ModalHeader>

        <ModalBody>
          <DetailedErrorAlert error={error} />

          <S3DirectoryForm handleAction={handleCreate} s3Directory={s3Directory} />
        </ModalBody>
      </Modal>
    </>
  );
};
